var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.users === null)?_c('InlineLoader'):_c('div',_vm._l((_vm.users),function(user){return _c('UserSearchDialogListItem',{key:user.id,attrs:{"user":user},on:{"click":function($event){return _vm.onUserClicked(user)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }